"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { IconGlyphicon } from 'generics/icons';
import { BootButton, CloseButton } from 'generics/buttons';
import MoneyUtil from 'components/moneyUtil';


export class ViewItemMarketDepthTotals extends React.Component  {
  render()  {
    const { total, type, orders } = this.props;

    if ( !orders.length )  {
      const noOrders = _I_(
            (type == "sell") ? "MarketDepthTotals.noOrders.sell" : "MarketDepthTotals.noOrders.buy"
          );
      return (<div className="view-market-depth-totals">{noOrders}</div>);
    }

    const starting = _I_(
          (type == "sell") ? "MarketDepthTotals.starting.sell" : "MarketDepthTotals.starting.buy"
        );
    const andMore = _I_(
          (type == "sell") ? "MarketDepthTotals.andMore.sell" : "MarketDepthTotals.andMore.buy"
        );

    return (<div className="view-market-depth-totals">
              {total} {starting} {orders[0].price} {andMore}
            </div>);
  }
}


export class ViewItemMarketDepthTable extends React.Component  {
  constructor(props)  {
    super(props);

    const market = MoneyUtil.formatCurr(SettingsInjections.getUsedCurrency().market);
    this.state = {  market  };
  }

  render()  {
    const {  orders,  total,  lines,  type  } = this.props;

    if ( !orders.length )
      return (<div  className="view-market-depth"  />);

    const clipped = orders.slice(0, lines);
    const clippedSum = clipped.reduce( (a,v)=>(a+v.count), 0 );
    if ( clippedSum < total )  {
      const ellipsis = _I_(
            (type == "sell") ? "MarketDepthTable.ellipsis.sell" : "MarketDepthTable.ellipsis.buy"
          );
      const last = clipped.pop();
      clipped.push({
          price:  `${last.price} ${ellipsis}`,
          count:  (total - clippedSum + last.count)
        });
    }

    return (
      <div  className="view-market-depth">
        <table className="table table-hover table-striped table-condensed">
          <thead>
            <tr>
              <th>{_I_("MarketDepthTable.caption.price")} ({this.state.market})</th>
              <th>{_I_("MarketDepthTable.caption.quantity")}</th>
            </tr>
          </thead>
          <tbody>
            {clipped.map(
                ({price, count})  =>  (<tr key={price}><td>{price}</td><td>{count}</td></tr>)
              )}
          </tbody>
        </table>
      </div>
      );
  }
}


export class ViewItemMarketDepthOwnWarning extends React.Component  {
  render()  {
    if ( !this.props.haveOwnOrders )  {
      return null;
    }

    const pending = _I_(
          (this.props.type == "sell") ? "MarketDepthOwnWarning.sell" : "MarketDepthOwnWarning.buy"
        );
    return (<div className="alert alert-warning">
              <IconGlyphicon type="warning-sign"/>&nbsp;{pending}
            </div>);
  }
}


defineSimpleTerm( "MarketDepthTotals.noOrders.sell",  "No sell orders",       {
  "ru_RU": "Нет ордеров на продажу",
  "cs_CZ": "Žádné příkazy k prodeji",
  "fr_FR": "Pas d'ordre de vente",
  "de_DE": "Keine Verkaufsaufträge",
  "it_IT": "Nessun ordine di vendita",
  "ko_KR": "판매 주문 없음",
  "pl_PL": "Brak poleceń sprzedaży",
  "pt_PT": "No sell orders",
  "es_ES": "No hay órdenes de venta",
  "zh_CN": "没有出售订单",
  "zh_TW": "沒有出售訂單"
} );


defineSimpleTerm( "MarketDepthTotals.noOrders.buy",  "No buy orders",       {
  "ru_RU": "Нет ордеров на покупку",
  "cs_CZ": "Žádné příkazy k nákupu",
  "fr_FR": "Pas d'ordre d'achat",
  "de_DE": "Keine Kaufaufträge",
  "it_IT": "Nessun ordine d'acquisto",
  "ko_KR": "구매 주문 없음",
  "pl_PL": "Brak poleceń kupna",
  "pt_PT": "No buy orders",
  "es_ES": "No hay órdenes de compra",
  "zh_CN": "没有购买订单",
  "zh_TW": "沒有購買訂單"
} );


defineSimpleTerm( "MarketDepthTotals.starting.sell",  "orders for sale starting at",       {
  "ru_RU": "ордер(а/ов) на продажу от",
  "cs_CZ": "příkazy k prodeji začínají na",
  "fr_FR": "le prix de vente commence à",
  "de_DE": "Verkaufsaufträge beginnen bei",
  "it_IT": "ordini di vendita a partire da",
  "ko_KR": "최소 판매가는 다음과 같습니다",
  "pl_PL": "polecenia sprzedaży zaczynają się od",
  "pt_PT": "orders for sale starting at",
  "es_ES": "órdenes de venta a partir de",
  "zh_CN": "订单出售开始时间：",
  "zh_TW": "訂單出售開始時間："
} );


defineSimpleTerm( "MarketDepthTotals.starting.buy",  "requests to buy starting at",       {
  "ru_RU": "ордер(а/ов) на покупку от",
  "cs_CZ": "poptávky ke koupi začínají na",
  "fr_FR": "demandes d'achat à partir de",
  "de_DE": "Kaufanfragen beginnen bei",
  "it_IT": "richieste d'acquisto a partire da",
  "ko_KR": "최대 구매가는 다음과 같습니다",
  "pl_PL": "oferty kupna zaczynają się od",
  "pt_PT": "requests to buy starting at",
  "es_ES": "solicitudes de compra a partir de",
  "zh_CN": "购买请求开始时间：",
  "zh_TW": "購買請求開始時間："
} );


defineSimpleTerm( "MarketDepthTotals.andMore.sell",  "and up",       {
  "ru_RU": "и выше",
  "cs_CZ": "a výše",
  "fr_FR": "et plus",
  "de_DE": "und bis zu",
  "it_IT": "fino a",
  "ko_KR": "이상",
  "pl_PL": "i powyżej",
  "pt_PT": "and up",
  "es_ES": "y mas",
  "zh_CN": "及以上",
  "zh_TW": "及以上"
} );


defineSimpleTerm( "MarketDepthTotals.andMore.buy",  "or lower",       {
  "ru_RU": "и ниже",
  "cs_CZ": "nebo méně",
  "fr_FR": "ou moins",
  "de_DE": "oder weniger",
  "it_IT": "o più bassi",
  "ko_KR": "이하",
  "pl_PL": "lub poniżej",
  "pt_PT": "or lower",
  "es_ES": "o menos",
  "zh_CN": "或以下",
  "zh_TW": "或以下"
} );


defineSimpleTerm( "MarketDepthOwnWarning.sell",  "You have pending sale orders",       {
  "ru_RU": "и выше",
  "cs_CZ": "You have pending sale orders",
  "fr_FR": "Vous avez des ordres de vente en attente",
  "de_DE": "Du hast ausstehende Verkaufsaufträge",
  "it_IT": "Hai degli ordini di vendita pendenti",
  "ko_KR": "판매 주문을 진행하시겠습니까",
  "pl_PL": "Masz oczekujące polecenia sprzedaży",
  "pt_PT": "You have pending sale orders",
  "es_ES": "Tienes pedidos de venta pendientes",
  "zh_CN": "你有等待中的出售订单",
  "zh_TW": "你有等待中的出售訂單"
} );


defineSimpleTerm( "MarketDepthOwnWarning.buy",  "You have pending buy orders",       {
  "ru_RU": "и ниже",
  "cs_CZ": "You have pending buy orders",
  "fr_FR": "Vous avez des ordres d'achat en attente",
  "de_DE": "Du hast ausstehende Kaufaufträge",
  "it_IT": "Hai degli ordini d'acquisto pendenti",
  "ko_KR": "구매 주문을 진행하시겠습니까",
  "pl_PL": "Masz oczekujące polecenia kupna",
  "pt_PT": "You have pending buy orders",
  "es_ES": "Tienes pedidos de compra pendientes",
  "zh_CN": "你有等待中的购买订单",
  "zh_TW": "你有等待中的購買訂單"
} );


defineSimpleTerm( "MarketDepthTable.caption.price",  "Price",       {
  "ru_RU": "Цена",
  "cs_CZ": "Cena",
  "fr_FR": "Prix",
  "de_DE": "Preis",
  "it_IT": "Prezzo",
  "ko_KR": "가격",
  "pl_PL": "Cena",
  "pt_PT": "Price",
  "es_ES": "Precio",
  "zh_CN": "价格",
  "zh_TW": "價格"
} );


defineSimpleTerm( "MarketDepthTable.caption.quantity",  "Quantity",       {
  "ru_RU": "Количество",
  "cs_CZ": "Množství",
  "fr_FR": "Quantité",
  "de_DE": "Anzahl",
  "it_IT": "Quantità",
  "ko_KR": "수량",
  "pl_PL": "Ilość",
  "pt_PT": "Quantity",
  "es_ES": "Cantidad",
  "zh_CN": "数量",
  "zh_TW": "數量"
} );


defineSimpleTerm( "MarketDepthTable.ellipsis.sell",  "and more",       {
  "ru_RU": "и выше",
  "cs_CZ": "a více",
  "fr_FR": "et plus",
  "de_DE": "und mehr",
  "it_IT": "ed altro",
  "ko_KR": "이상",
  "pl_PL": "i więcej",
  "pt_PT": "and more",
  "es_ES": "y mas",
  "zh_CN": "及以上",
  "zh_TW": "及以上"
} );


defineSimpleTerm( "MarketDepthTable.ellipsis.buy",  "and lower",       {
  "ru_RU": "и ниже",
  "cs_CZ": "a méně",
  "fr_FR": "et moins",
  "de_DE": "und weniger",
  "it_IT": "e più bassi",
  "ko_KR": "이하",
  "pl_PL": "i mniej",
  "pt_PT": "and lower",
  "es_ES": "y menos",
  "zh_CN": "及以下",
  "zh_TW": "及以下"
} );

